import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { promptBox } from '../PromptBox';
import {
    Dropdown,
    Tooltip as NCTooltip,
    HotKeys as NCHotKeys,
    Button as NCButton,
    Checkbox as NCCheckbox,
    Switch,
    Input as NCFormControl,
    getFunctionDisplay,
    MultiLangText as NCMultiLangText,
} from '@platform/base';
import { getAllSearchDataEve, clearAllValueEve, pageQuery, getICFlag, setICFlag } from './methods';
import {
    templateFilter,
    initSimpleSnap,
    getTimezoneOffset,
    _clone,
    allItemsFillComplete,
    beSureBtnClick,
    setDefaultScheme,
    beSureBtnClick_Del,
    tree2Array,
    createOperation,
    setSearchCacheData,
    autoSearchConfigOpt,
} from './_methods';
import {
    getSysFieldid,
    isFunction,
    isEmpty,
    PubSub,
    setGlobalStorage,
    serverTimeToLocal,
    formatDatetime,
    moment,
    createOperationIcon,
    getGlobalStorage,
    getAppReqParam,
    ajax,
    ViewModel,
    getAppUrl,
    microAppUtil,
} from '@platform/api';
import { templateEngine } from './templateEngine';
// 外层方案
import Item from './item';
import TipsTitle from './TipsTitle';

// 查询区每一项
import SearchItem from './searchItem';
import SortDropdown from './SortDropdowm';
import { object } from 'prop-types';
import { error } from '../../FastExtend/utils/log';

// 查询区渲染完成发布订阅标识
const BEFORECOMPLETE = 'beforeAreaChangeComplete';
const COMPLETE = 'areaChangeComplete';
const INITNUM = 6;

export default class SearchSimCom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLable: props.showLable, //是否显示名称
            showFlag: true, //控制是否显示修改方案名称的输入框
            checked: false,
            showPlanItem: false,
            focusItem: '',
            isIgnoreCase: getICFlag(props.moduleId),
            isAutoExcuSearch: autoSearchConfigOpt('get', props.moduleId),
            
        };  
        this.editPlanType = '' ;
        this.targetEditPlan = null;
    }

    PMF=() => {
        let insideTab = JSON.parse(sessionStorage.getItem('start-tab'));
        let firstScreenTime = (top.performance.now()) / 1000;

        if(insideTab){
            firstScreenTime = (top.performance.now() - top.qiankun_start_time) / 1000;
        }
        let title = null;
        let pageid = getAppUrl().pageid;
        let qiankunContainer = document.querySelector(`#microApp-${pageid}`);
        if(qiankunContainer){
            title = qiankunContainer.querySelector('.bill-info-title');
        }else{
            title = document.querySelector('.bill-info-title');
        }
        title.innerText = title.innerText + " 首屏时间：" + firstScreenTime ;
    }

    componentDidMount() {
        const thisDom = ReactDOM.findDOMNode(this);
        this.searchNameDOM =
            thisDom && thisDom.querySelector('.search-name-wrapper');
        document.addEventListener('click', this.onMousedownEvent);

        // this.searchBtnDOM = document.querySelector(
        //     '.searchBtnName-searchBtn'
        // );

        //是否显示自动执行查询按钮
        let { context = {}, moduleId } = this.props;
    
        let autoSearchPageCode = (context.pageParamMap?.autoSearch || context.pageParamMap?.autosearch) ?? '';
        let autoSearchPageCodeArr = autoSearchPageCode.split(',') || [];
        let autoSearchSwitchArr = [];
        let autoSearchUrlArr = [];
        autoSearchPageCodeArr.forEach(item => {
            let firstValue = item.split('\"')[0] || [];
            let secondeValue = item.split('\"')[1] || [];
            if(firstValue.includes('/')){
                autoSearchSwitchArr.push(firstValue.slice(0, firstValue.length - 1));
            }else{
                autoSearchSwitchArr.push(firstValue);
            }
            autoSearchUrlArr.push(secondeValue);
        });

        let showAutoSearchBtn = autoSearchSwitchArr.includes(moduleId);
        if(this.state.isAutoExcuSearch && showAutoSearchBtn){
            //如果是自动查询的话，配置了URL，查询前先存个变量存在view modal中
            ViewModel.setData('searchUrlCache', autoSearchUrlArr);
            setTimeout(() => {
                this.props._this.clickSearch();
            }, 500);
        }

        //内部页签测试代码 后续去掉
        if(localStorage.getItem('open-tab-time')){
            this.PMF();
        } 
    }
    onMousedownEvent = e => {
        let showPlanItem = false;
        if (this.searchNameDOM) {
            let po = this.searchNameDOM.getBoundingClientRect();
            let { height } = po;
            if (
                height &&
                e.target &&
                Object.prototype.toString
                    .call(e.target.className)
                    .slice(8, -1) === 'String' &&
                (e.target.className.includes('icon-not-visible') || 
                (e.target.parentElement && e.target.parentElement.className && e.target.parentElement.className.includes('icon-not-visible')) ||
                (e.target.parentElement && 
                    e.target.parentElement.parentElement &&
                    e.target.parentElement.parentElement?.className &&
                    !e.target.parentElement.parentElement?.className?.includes('searchPlanModal') &&
                    e.target.className.includes('uf-close-c')))
            ) {
                
                showPlanItem = this.state.showPlanItem && true;
                if (e.target.className.includes('icon-bangzhutishi')) {
                    return;
                }
            }
        }
        if (this.searchNameDOM?.contains(e.target)) {
            showPlanItem = this.state.showPlanItem;
        }
        if (showPlanItem === this.state.showPlanItem) {
            return;
        }
        this.setState({ showPlanItem });
    };
    onChangePlanVisible = () => {
        this.props.getQueryScheme({ isAdvSearch: true });
        this.setState({ showPlanItem: !this.state.showPlanItem });
    };
    componentWillUnmount() {
        document.removeEventListener('click', this.onMousedownEvent);
    }
    componentDidUpdate() {
        const thisDom = ReactDOM.findDOMNode(this);
        this.searchNameDOM =
            thisDom && thisDom.querySelector('.search-name-wrapper');
    }
    render() {
        return NCCreateSearch.call(this, this.props);
    }
}

function NCCreateSearch({
    moduleId,
    oid,
    metaId,
    meta,
    clickSearchBtn, // 查询按钮点击事件回调，只返回公共查询条件，不包含自定义查询条件；如果有自定义查询条件，需要业务组在clickPlanEve方法中接收查询方案信息，并保存到业务组的state中，然后在 clickSearchBtn方法中自行合并公共条件和自定义条件。
    searchBtnName = '',
    onAfterEvent, // 编辑后事件
    onBeforeEvent,
    showSearchBtn = true, // 是否显示查询按钮 ,默认显示
    showAdvBtn = true, // 是否显示高级查询按钮和查询方案按钮 ,默认显示
    hideMoreBtn = false,
    showClearBtn = true, // 是否显示清空按钮
    replaceAdvBtnEve, // 业务组替换高级面板 (fun)
    saveSearchPlan, // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
    clickPlanEve, // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
    clickAdvBtnEve, //单击高级之后的回调方法
    hideBtnArea = false, // 隐藏查询按钮区域，默认false
    advSearchClearEve, // 高级查询面板中的清空按钮 点击事件回调，用于业务组清除自定义查询条件值
    advSearchClearCurrentEve,
    onlyShowSuperBtn = false, // 只显示高级按钮
    showFoldBtn = true,
    superBtnFieldid = 'replaceSuper',
    replaceSuperBtn = '', // 只显示高级按钮时替换高级按钮
    onOperateTypeChange, // 操作符改变时的回调
    onlyShowAdvArea = false, //在查询区只显示 高级查询部分
    onlyShowModal = false, //在查询区只显示模态框
    statusChangeEvent, //状态切换
    context = {},
    renderItem = {},
    setInitValueEvent,
    onlyShowPlan = false, // 只显示方案列表和高级查询
    currentSearch = true,
    fieldid,
    opneBtnClick, //点击展开收起的回调
    onlyShowSuperCondition = false,
    showAdvSearchPlanBtn, // 是否显示保存另存方案按钮
    showAddSearchPlan,
    hiddenFunList,
    hideSearchPlan,
    modalCloseEve,
    clickShowLableEve,
    showSearchLable,
    searchAdvBtnClick,
    isWidgetMode,
    runMode,
    underlineBorder,
    maxColumn
} = {}) {
    let searchInfo = this.props.searchInfo;
    let multiLang = this.props.multiLang;
    let LangData = this.props.LangData;
    let setStateEve = this.props.setStateEve;

    //是否显示自动执行查询按钮
    let appReqParam = getAppReqParam();
    let autoSearchPageCode = (context.pageParamMap?.autoSearch || context.pageParamMap?.autosearch) ?? '';
    let autoSearchPageCodeArr = autoSearchPageCode.split(',');
    let autoSearchSwitchArr = [];
    let autoSearchUrlArr = [];
    autoSearchPageCodeArr.forEach(item => {
        let firstValue = item.split('\"')[0] || [];
        let secondeValue = item.split('\"')[1] || [];
        if(firstValue.includes('/')){
            autoSearchSwitchArr.push(firstValue.slice(0, firstValue.length - 1));
        }else{
            autoSearchSwitchArr.push(firstValue);
        }
        autoSearchUrlArr.push(secondeValue);
    });

    let showAutoSearchBtn = autoSearchSwitchArr.includes(moduleId);

    //删除方案时调用
    this.props._this.chooseSearchPlan = (item, flag) => {
        chooseSearchPlan(item, flag);
    };

    //检查请求返回数据是否与上一次相同，利用缓存

    //点击查询按钮事件
    const clickSearch = (this.props._this.clickSearch = (
        event,
        customQueryCondition,
    ) => {

        setTimeout(() => {
            let type = 'simple';

            let snapshot = searchInfo.snapshotMap[searchInfo.status];
            let data =
                customQueryCondition ||
                getAllSearchDataEve(searchInfo, snapshot, context, true); //在getAllSearchDataEve中返回数据中的oprtype
            if (data) {
                let template = templateFilter(searchInfo.itemsMap, snapshot);
                let ordercondition = _clone(searchInfo.sortField);
                let addOrderConditionInfo = {};
                ordercondition.forEach((item, index) => {
                    addOrderConditionInfo[item.refcode] = { orderposition:index };
                    if(item.ordertype === '1'){
                        addOrderConditionInfo[item.refcode]['ordertype'] = 'asc';
                    }else if(item.ordertype === '2'){
                        addOrderConditionInfo[item.refcode]['ordertype'] = 'desc';
                    }else{
                        addOrderConditionInfo[item.refcode]['ordertype'] = '';
                    }
                });
                let dataConditionPks = [];
                data.conditions.forEach(e => {
                    if(Object.keys(addOrderConditionInfo).includes(e.field)){
                        if(addOrderConditionInfo[e.field].ordertype !== ''){
                            e['orderCondition'] = addOrderConditionInfo[e.field];
                        }
                    }
                    dataConditionPks.push(e.field);
                });

                Object.keys(addOrderConditionInfo).forEach(e => {
                    if(!dataConditionPks.includes(e) && addOrderConditionInfo[e].ordertype !== ''){
                        data.conditions.push({ field:searchInfo.itemsMap[e].attrcode, datatype:searchInfo.itemsMap[e].datatype, orderCondition:addOrderConditionInfo[e], def5:searchInfo.itemsMap[e].label, value:{}, oprtype: "=", originOptSigns: "=" });
                    }
                });

                let finalData = {
                    queryAreaCode: moduleId,
                    oid,
                    querytype: 'tree',
                    querycondition: data,
                    template,
                    isAddContent: searchInfo.addChecked || false,
                    nctz: getTimezoneOffset(),
                    // ordercondition: ordercondition.filter(
                    //     (item) => item._checked === true
                    // ),
                };

                if (clickSearchBtn && typeof clickSearchBtn == 'function') {
                    clickSearchBtn(
                        {
                            ...this.props._this._this,
                            ...this.props._this._this.props,
                        },
                        data,
                        type,
                        data && finalData,
                    );
                    // 点击查询以后存储下当前查询条件 维度是 用户id + appCode + pageCode
                    let pageMeta = this.props._this._this.meta.getMeta();
                    let { clickSearchBtn: clickSearchBtnCallback } =
                        this.props._this.state.searchInfo;
                    // 存一个变量，如果表格上已经配置了空指引的回调，那就不用去layout里查询了
                    let tableQuery = false;
                    if (
                        clickSearchBtnCallback &&
                        Array.isArray(clickSearchBtnCallback)
                    ) {
                        tableQuery = clickSearchBtnCallback.some(
                            callback => callback?.tableQuery === true,
                        );
                    }
                    //记录一下查询时候的条件
                    searchInfo.lastSearchCondition = _clone(data);
                    let addSearchCallback = () => {
                        // 执行智能分析绑定的查询按钮点击事件
                        if (
                            !customQueryCondition &&
                            clickSearchBtnCallback &&
                            Array.isArray(clickSearchBtnCallback)
                        ) {
                            clickSearchBtnCallback.forEach(fun => {
                                typeof fun.callback == 'function' &&
                                    fun.callback(
                                        {
                                            ...this.props._this._this,
                                            ...this.props._this._this.props,
                                        },
                                        data,
                                        type,
                                        data && finalData,
                                    );
                            });
                        }
                    };
                    setSearchCacheData.call(this.props._this._this, {
                        moduleId,
                        finalData: { ...finalData, snapshot },
                        meta: pageMeta,
                        callback: addSearchCallback,
                        tableQuery,
                    });
                }

                this.forceUpdate();
            }
        }, 300);
    });

    //重置按钮事件
    const resetEvent = () => {
        let oldvalue = _clone(searchInfo.snapshotMap[searchInfo.status]);
        let snapshot = searchInfo.snapshotMap[searchInfo.status];
        clearAllValueEve.call(this.props._this, snapshot);
        this.state.searchInfo = searchInfo;
        if (advSearchClearEve && typeof advSearchClearEve == 'function') {
            advSearchClearEve(oldvalue);
        }
        setStateEve();
    };

    //显示lable回调
    const onShowNameChange = () => {
        this.setState({ showLable: !this.state.showLable });
        setGlobalStorage('localStorage', 'showLable', !this.state.showLable);
        clickShowLableEve && clickShowLableEve();
        PubSub.publishSync(BEFORECOMPLETE, true);
        setStateEve(() => {
            // 发布通知表格更新高度
            this.props._this._this.infoExchangeController.publishSync(
                'heightChange',
                { area: 'searchArea', target: ReactDOM.findDOMNode(this) },
            );
        });
    };

    //查询忽略大小写回调
    const onIgnoreCase = () => {
        setICFlag(moduleId, !this.state.isIgnoreCase );
        this.setState({ isIgnoreCase: !this.state.isIgnoreCase });
    };

    //自动查询
    const onAutoSearch = () => {
        autoSearchConfigOpt('set', moduleId, !this.state.isAutoExcuSearch);
     
        this.setState({ isAutoExcuSearch: !this.state.isAutoExcuSearch });
    };

    const onHasFocus = attrcode => {
        this.setState({ focusItem: attrcode });
    };

    /* 新增方案按钮 */
    const addSearchPlanClick = () => {
        if (searchInfo.status !== 'simple') {
            return;
        }
        this.props.searchInfo.searchPlanName = {};
        this.editPlanType = 'add';
        this.props.modal.show('outAddSearchPlan@' + this.props.moduleId);
        this.forceUpdate();
    };
    //方案重命名
    const renameSearchPlan = target => {
        this.targetEditPlan = target;
        const name123 = this.props.searchInfo.multiLangOpt.createName123(target);
        this.props.searchInfo.searchPlanName = this.props.searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);
        this.editPlanType = 'edit';
        this.props.modal.show('outAddSearchPlan@' + this.props.moduleId);
        this.setState({ showPlanItem:false });

    };

    const searchPlanNameChange = (type, value, index) => {
        if(type === 'onchange'){
            searchInfo.searchPlanName = value;
        }else if(type === 'onblur'){
            searchInfo.searchPlanName = searchInfo.multiLangOpt.synchronousMultiLangValue(value, index) ;
        }
        
        setStateEve();
    };

    /* 修改方案模态框 */
    const modalContent = (status, flag, currentPlan, searchPlanName, scope) => {
        
        return (
            <div className="plan-content">
                <span className="label">
                    {multiLang['page-search-0012'] + ' '}
                </span>
                <span className="content">
                    <NCHotKeys
                        keyMap={{ high: ['enter'] }}
                        handlers={{
                            high: e =>
                                beSureBtnClick.call(
                                    this.props._this,
                                    status,
                                    flag,
                                    currentPlan,
                                    searchPlanName,
                                    this.state.checked,
                                    searchInfo.sortField,
                                    scope,
                                    e,
                                ),
                        }}
                    >
                        <NCMultiLangText
                            id='NC_searchPlanOutInput'
                            fieldid="NC_searchPlanModalText"
                            className="searchPlanModal"
                            attrcode="name"
                            languageMeta={context.languageMetas}
                            onChange={searchPlanNameChange.bind(this, 'onchange')}
                            maxlength={100}
                            onBlur={searchPlanNameChange.bind(this, 'onblur')}
                            // onSelect={this.handleSelect}
                            value={searchPlanName}
                        />
                    </NCHotKeys>
                </span>
                {status === 'add' ? <div
                    className="setdefault"
                    onClick={() => {
                        this.setState({ checked: !this.state.checked });
                    }}
                >
                    <NCCheckbox
                        checked={this.state.checked}
                        onClick={() => {
                            this.setState({ checked: !this.state.checked });
                        }}
                    />
                    <span className="default-lable">
                        {multiLang['page-search-0099']}
                    </span>
                </div> : null}
            </div>
        );
    };

    const onInputFocus = () => {
        document.getElementById('NC_searchPlanOutInput').focus();
    };

    //生成查询、清空、高级 ,展开收起按钮
    const createButton = hasFold => {
        let foldClass = hasFold ? ' search-component-fold' : '';
        let currentPlan = searchInfo.currentPlan;
        let showIgnoreCaseSwitch = searchInfo.showIgnoreCaseSwitch;
        
        return (
            <div className={'search-component-rowArea' + foldClass}>
                <SortDropdown
                    searchInfo={searchInfo}
                    multiLang={multiLang}
                ></SortDropdown>

                {/**查询按钮，当展开的时候显示，收起时不显示 */}
                {!hasFold && !onlyShowSuperBtn && showSearchBtn && (
                    <NCTooltip
                        delayShow={800}
                        inverse
                        delayHide={0}
                        overlay={
                            <div>
                                {typeof searchBtnName == 'string'
                                    ? searchBtnName
                                    : `${multiLang['page-search-0001']}(Enter)`}
                            </div>
                        }
                        placement="top"
                    >
                        <span
                            fieldid={getSysFieldid('search_btn')}
                            className={
                                showAdvBtn
                                    ? 'search-component-searchBtn searchBtnName-searchBtn'
                                    : 'search-component-searchBtn searchBtnName-searchBtn hide-adv-btn'
                            }
                            onClick={clickSearch.bind(this)}
                        >
                            {searchBtnName}
                        </span>
                    </NCTooltip>
                )}
                {/** 高级按钮 只有在不需要高级功能的情况下不显示*/}
                {!onlyShowSuperBtn && showAdvBtn && (
                    <NCTooltip
                        delayShow={800}
                        inverse
                        delayHide={0}
                        overlay={
                            <div
                                style={{ padding: '0' }}
                            >{`${multiLang['page-search-0003']}(F3)`}</div>
                        }
                        placement="top"
                    >
                        <span
                            className="superBtn"
                            onClick={() => {
                                searchAdvBtnClick(searchInfo);
                            }}
                        >
                            <i className="iconfont icon-gaojichaxun" />
                        </span>
                    </NCTooltip>
                )}
                {/**更多按钮图标, 当展开的时候需要，收起不需要 */}
                {!hasFold &&
                    !onlyShowSuperBtn &&
                    !hideMoreBtn &&
                    (showAdvBtn || showClearBtn || showSearchLable) && (
                    <Dropdown
                        trigger={['hover']}
                        placement="bottomLeft"
                        delay={300}
                        overlay={
                            <ul className="menu_items first_level">
                                {showAdvBtn &&
                                        showAdvSearchPlanBtn &&
                                        !currentPlan.isprepared && (
                                    <li
                                        key="1"
                                        onClick={beSureBtnClick.bind(
                                            this.props._this,
                                            'save',
                                            true,
                                            searchInfo.currentPlan,
                                            "",
                                            false,
                                            searchInfo.sortField,
                                            this,
                                        )}
                                    >
                                        <span>
                                            {
                                                multiLang[
                                                    'page-search-0008'
                                                ]
                                            }
                                        </span>
                                        <span>Ctrl+S</span>
                                    </li>
                                )}
                                {showAdvBtn &&
                                        showAddSearchPlan &&
                                        showAdvSearchPlanBtn && (
                                    <li
                                        key="2"
                                        onClick={addSearchPlanClick.bind(
                                            this,
                                        )}
                                    >
                                        <span>
                                            {
                                                multiLang[
                                                    'page-search-0081'
                                                ]
                                            }
                                        </span>
                                        <span>Ctrl+Shift+S</span>
                                    </li>
                                )}
                                {showClearBtn && (
                                    <li
                                        key="3"
                                        fieldid={getSysFieldid(
                                            'searchClear_btn',
                                        )}
                                        onClick={resetEvent}
                                    >
                                        <span>
                                            {multiLang['page-search-0002']}
                                        </span>
                                        <span>Alt+Del</span>
                                    </li>
                                )}
                                {showSearchLable && (
                                    <li key="4" onClick={onShowNameChange}>
                                        <span>
                                            {multiLang['page-search-0096']}
                                        </span>{' '}
                                        <span>
                                            <Switch
                                                checked={
                                                    this.state.showLable
                                                }
                                            ></Switch>
                                        </span>
                                    </li>
                                )}
                                {
                                    showAutoSearchBtn && (<li key="5" onClick={onAutoSearch}>
                                        <span>{multiLang['page-search-0122'] || '自动执行查询'}</span>
                                        <span>
                                            <Switch
                                                checked={
                                                    this.state.isAutoExcuSearch
                                                }
                                            ></Switch>
                                        </span>
                                    </li>)
                                }
                                { showIgnoreCaseSwitch && (<li key="6" onClick={onIgnoreCase}>
                                    <span>{multiLang['page-search-0123'] || '精确匹配大小写'}</span>
                                    <span>
                                        <Switch
                                            checked={!this.state.isIgnoreCase}
                                        ></Switch>
                                    </span>
                                </li>)
                                    
                                }
                            </ul>
                        }
                    >
                        <span className="moreBtn">
                            <i className="iconfont icon-gengduo" />
                        </span>
                    </Dropdown>
                )}
                {/** 展开收起图标*/}
                {!onlyShowSuperBtn && !onlyShowPlan && showFoldBtn && (
                    <NCTooltip
                        delayShow={800}
                        inverse
                        delayHide={0}
                        overlay={
                            <span>
                                {searchInfo.showSearchItems
                                    ? multiLang['page-search-0087']
                                    : multiLang['page-search-0088']}
                            </span>
                        }
                        placement="top"
                    >
                        <span
                            className="search-open-icon"
                            onClick={() => {
                                searchInfo.showSearchItems =
                                    !searchInfo.showSearchItems;
                                PubSub.publishSync(BEFORECOMPLETE, true);
                                setStateEve(() => {
                                    // 发布通知表格更新高度
                                    this.props._this._this.infoExchangeController.publishSync(
                                        'heightChange',
                                        { area: 'searchArea', target: ReactDOM.findDOMNode(this) },
                                    );
                                    opneBtnClick && opneBtnClick();
                                });
                            }}
                        >
                            <i
                                style={
                                    searchInfo.showSearchItems
                                        ? {
                                            transform: 'rotate(180deg)',
                                            display: 'inline-block',
                                        }
                                        : {}
                                }
                                className="iconfont icon-shouqi4"
                            />
                        </span>
                    </NCTooltip>
                )}
                {/** 只显示高级按钮*/}
                {onlyShowSuperBtn && (
                    <NCButton
                        style={{ maxWidth: onlyShowSuperBtn ? 'initial' : '29%' }}
                        colors="primary"
                        onClick={searchAdvBtnClick.bind(this, searchInfo)}
                        fieldid={getSysFieldid(superBtnFieldid)}
                    >
                        {replaceSuperBtn || multiLang['page-search-0003']}
                    </NCButton>
                )}
            </div>
        );
    };

    const clearRquiredWraning = item => {
        if (item) {
            PubSub.publish('clearWarning', {
                data: item.attrcode,
                status: 'simple',
                moduleId: moduleId,
            });
        }
    };
    // 生成查询条件
    const createDom = (snapshotItem, buttonFlag, zindex, index, count) => {
        let showLableFlag = showSearchLable && this.state.showLable;
        let classLable = showLableFlag ? ' search-button-lable' : '';
        let sortField = searchInfo.sortField.filter(
            item => item.ordertype !== '0',
        );
        let sortFlag = sortField.length === 0 ? false : true;
        const rowColoumn = maxColumn || INITNUM
        count = count > rowColoumn ? rowColoumn : count;
        if (buttonFlag && zindex === 0) {
            return (
                !searchInfo.showSearchItems && (
                    <div className={'search-button' + classLable}>
                        {hideBtnArea ? null : createButton()}
                    </div>
                )
            );
        }
        let templetItem = searchInfo.itemsMap[snapshotItem.attrcode];
        let initialvalue = snapshotItem.initialvalue;
        if (!templetItem) {
            //toast({ content: '查询方案损坏！', color: 'warning' });
            return null;
        } else {
            // 通过api设置值
            if (searchInfo.status === 'simple') {
                if (initialvalue?.value) {
                    if (Array.isArray(initialvalue.value)) {
                        if (initialvalue.value[0] || initialvalue.value[1]) {
                            clearRquiredWraning(templetItem);
                        }
                    } else if (templetItem.itemtype === 'refer') {
                        initialvalue.display &&
                            clearRquiredWraning(templetItem);
                    } else {
                        clearRquiredWraning(templetItem);
                    }
                } else if (!templetItem.required) {
                    clearRquiredWraning(templetItem);
                }
            }
            let dom = new templateEngine({
                moduleId,
                isAdvDom: false,
                searchInfo,
                snapshotItem,
                onAfterEvent,
                onBeforeEvent,
                setStateEve,
                renderItem,
                context: this.props.context,
                multiLang,
                LangData,
                clickSearch,
                hiddenFunList,
                showLableFlag,
                showSearchLable,
                onOperateTypeChange,
                onHasFocus,
                focusAttrcode: this.state.focusItem,
                status: searchInfo.status,
                underlineBorder,
            });
            return (
                <SearchItem
                    areaId={moduleId}
                    uniqueKey={searchInfo.uniqueKey}
                    key={
                        searchInfo.currentPlan.pk_ncc_queryscheme +
                        snapshotItem.attrcode +
                        zindex +
                        index
                    }
                    name={snapshotItem.attrcode}
                    itemtype={templetItem.itemtype}
                    limit={count}
                    sortFlag={sortFlag}
                    status="simple"
                    fieldid={getSysFieldid(snapshotItem.attrcode)}
                    className="search-item-wrap"
                    dom={dom}
                    hotkeytag={`searchArea-${snapshotItem.attrcode}`}
                />
            );
        }
    };

    // 点击查询方案
    const chooseSearchPlan = (item, flag, e) => {
        if (
            item.pk_ncc_queryscheme == searchInfo.currentPlan.pk_ncc_queryscheme
        ) {
            return;
        }
        let attrcodeArr = [];
        searchInfo.status = 'simple';
        searchInfo.currentPlan = item;
        searchInfo.isDefaultPlan = item.pk_ncc_queryscheme == '001';
        const name123 = searchInfo.multiLangOpt.createName123(item);
        searchInfo.searchPlanName = searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);

        if(item.sortfield){
            //如果此时模板上新增或删除了某一个字段设置默认，还得进行一次过滤
            let finalSortField = [];
            let schemaSortField = item.sortfield;
            let metaSortfield = this.props.meta.sortField || [];
            let schemaSortObj = {};
            let metaSortObj = {};
            let newAddSortField = [];
            schemaSortField.forEach(item => {
                schemaSortObj[item.refcode] = item;
            });
            metaSortfield.forEach(item => {
                metaSortObj[item.refcode] = item;
            });
            schemaSortField.forEach(item => {
                if(Object.keys(metaSortObj).includes(item.refcode)){
                    finalSortField.push(item);
                }
            });

            metaSortfield.forEach(item => {
                if(!Object.keys(schemaSortObj).includes(item.refcode)){
                    newAddSortField.push(item);
                }
            });
            item.sortfield = [...finalSortField, ...newAddSortField];

            searchInfo.sortField = item.sortfield;
        }else{
            searchInfo.sortField.map(item => {
                item.ordertype = '0';
            });
        }

        initSimpleSnap(context, searchInfo, item, false, false, true);
        searchInfo.snapshotMap.simple = item.renderobj4web_snap;
        if (isFunction(clickPlanEve)) {
            clickPlanEve(item, this.props._this._this);
        }
        isFunction(setInitValueEvent) && setInitValueEvent('simple');
        isFunction(statusChangeEvent) && statusChangeEvent('simple');

        if (
            isFunction(clickSearchBtn) &&
            allItemsFillComplete(
                searchInfo.snapshotMap[searchInfo.status],
                searchInfo,
                context,
            ) &&
            flag !== false
        ) {
            clickSearch();
        }
        setStateEve();
        //选择查询方案的时候触发变化方法
        this.props._this._this.infoExchangeController.publish('heightChange', {
            area: 'searchArea',
            target: ReactDOM.findDOMNode(this),
        });
        // 发布通知表格更新高度
        PubSub.publish(COMPLETE, true);
        // 切换方案时  clearWraning
        // PubSub.publish('clearWarning', { data: attrcodeArr, status: searchInfo.status, moduleId: moduleId });
    };

    /* 删除查询方案 */
    const delSearchPlan = pk_ncc_queryscheme => {
        promptBox({
            color: 'warning',
            hotKeyboard: true,
            title: multiLang['page-search-0031'],
            content: <div>{multiLang['page-search-0015']}</div>, // 提示内容,非必输
            beSureBtnName: multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
            cancelBtnName: multiLang['page-search-0010'],
            beSureBtnClick: beSureBtnClick_Del.bind(
                this.props._this,
                true,
                pk_ncc_queryscheme,
            ),
        });
        this.setState({ showPlanItem:false });
    };
    // 创建查询方案
    const createSearchPlan = () => {
        // console.log(searchInfo)
        // let searchPlan = searchInfo.searchPlanCache;

        let searchPlan = Array.isArray(searchInfo.searchPlanCache)
            ? [...searchInfo.searchPlanCache].filter(
                e => e.visible === true || e.visible === undefined,
            )
            : [];

        let dom = null;
        if (!searchPlan || !searchPlan.length) {
            dom = (
                <a>
                    <p
                        className="searchPlanList"
                        fiedlid={`${multiLang['page-search-0019']}_sub-btn`}
                    >
                        <span className="searchPlanName">
                            {multiLang['page-search-0019']}
                        </span>
                    </p>
                    <p
                        className="searchPlanList"
                        fiedlid={`${multiLang['page-search-0020']}_sub-btn`}
                    >
                        <span
                            className="addSearchPlanHref"
                            onClick={searchAdvBtnClick.bind(this, searchInfo)}
                        >
                            {multiLang['page-search-0020']}
                        </span>
                    </p>
                </a>
            );
        } else {
            // 外层方案查询 (已提出,可放置到内部)
            // const name123 = searchInfo.multiLangOpt.createName123(searchInfo);
            // let multiLangName = searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);
            // searchInfo['name'] = searchInfo['name'] || searchInfo.searchPlanName;
            
            dom = searchPlan.map((key, index) => (
                <p
                    key={key.pk_ncc_queryscheme}
                    className="searchPlanList"
                    fielid={`${key.name}_sub-btn`}
                >
                    <Item
                        item={key}
                        value={key.labelName}
                        searchInfo={searchInfo}
                        meta={meta}
                        context={context}
                        chooseSearchPlan={chooseSearchPlan.bind(this, key)}
                        searchAdvBtnClick={searchAdvBtnClick.bind(
                            this,
                            searchInfo,
                            '2',
                            key.labelName,
                        )}
                        // editSearchPlan={editSearchPlan.bind(this)}
                        delSearchPlan={delSearchPlan.bind(
                            this,
                            key.pk_ncc_queryscheme,
                        )}
                        renameSearchPlan = {renameSearchPlan.bind(this, key)}
                        // beSureBtnClick={searchPlanName => {
                        //     beSureBtnClick.call(
                        //         this.props._this,
                        //         'edit',
                        //         true,
                        //         key,
                        //         searchPlanName,
                        //         false,
                        //         searchInfo.sortField,
                        //         this,
                        //         undefined,
                        //         // multiLangName,
                        //         // {
                        //         //     name1:{value:searchInfo.name},
                        //         //     name2:{value:(searchInfo.name2 ? searchInfo.name2 : searchInfo.name)},
                        //         //     name3:{value:(searchInfo.name3 ? searchInfo.name3 : searchInfo.name)}
                        //         // }
                        //     );
                        // }}
                        showFlag={this.state.showFlag}
                        setDefaultScheme={pk_ncc_queryscheme => {
                            setDefaultScheme.call(
                                this.props._this,
                                true,
                                key,
                                pk_ncc_queryscheme,
                                oid,
                                key.pk_queryscheme_share,
                            );
                        }}
                        multiLang={multiLang}
                        runMode={runMode}
                    />
                </p>
            ));
        }
        return <div className="searchPlanBox">{dom}</div>;
    };

    const getFuntionValue = (item, multiLang) => {
        let temItem = searchInfo.itemsMap[item.attrcode];
        // const functionList = {
        //     '#day(-1)#': multiLang['page-search-0060'],
        //     '#day(0)#': multiLang['page-search-0061'],
        //     '#day(1)#': multiLang['page-search-0062'],
        //     '#month(-1)#': multiLang['page-search-0063'],
        //     '#month(0)#': multiLang['page-search-0064'],
        //     '#month(1)#': multiLang['page-search-0065'],
        //     '#week(-1)#': multiLang['page-search-0066'],
        //     '#week(0)#': multiLang['page-search-0067'],
        //     '#week(1)#': multiLang['page-search-0068'],
        //     '#quarter(-1)#': multiLang['page-search-0069'],
        //     '#quarter(0)#': multiLang['page-search-0070'],
        //     '#quarter(1)#': multiLang['page-search-0071'],
        //     '#year(-1)#': multiLang['page-search-0072'],
        //     '#year(0)#': multiLang['page-search-0073'],
        //     '#year(1)#': multiLang['page-search-0074'],
        //     '#lastDayOfMonth#': multiLang['page-search-0075'],
        //     '#lastDayOfWeek#': multiLang['page-search-0076'],
        //     '#finalDayOfLastMonth#': multiLang['page-search-0077'],
        //     '#past#': multiLang['page-search-0100'], //至过去
        //     '#future#': multiLang['page-search-0101'], //至未来
        // };
        let timeItemList = [
            'datepicker',
            'datetimepicker',
            'rangepicker',
            'NCTZDatePickerStart',
            'NCTZDatePickerEnd',
            'NCTZDatePickClientTime',
            'NCTZDatePickClientHourTime',
            'NCTZDatePickerRangeDay',
            'datePickerNoTimeZone',
        ];
        let valArr = [];
        let resultArr = [];
        let val = item.initialvalue.value;
        let operationSign = item.operationSign;
        let itemtype = item.itemtype;
        let isconverttimezones = item.isconverttimezones;
        let dateFlag = itemtype === 'datetimepicker' ? 'datetime' : 'date';
        let range =
            operationSign === 'between' || operationSign === 'not between'
                ? true
                : false;
        let singleValue;
        if (itemtype === 'NCTZDatePickerEnd') {
            singleValue = 'end';
        } else if (itemtype === 'NCTZDatePickerStart') {
            singleValue = 'start';
        }
        if (val) {
            if (typeof val === 'string' && range) {
                valArr = val.split(',');
            } else if (Array.isArray(val)) {
                valArr = val;
            } else {
                valArr = [val];
            }
        }
        for (var i = 0; i < valArr.length; i++) {
            if (valArr[i] && timeItemList.includes(itemtype)) {
                if (valArr[i].indexOf('#') !== -1) {
                    let timeValue = getFunctionDisplay(valArr[i], {
                        ...temItem,
                        range,
                        multiLang,
                        singleValue,
                    });
                    if (range) {
                        timeValue[i] && resultArr.push(timeValue[i]);
                    } else {
                        timeValue && resultArr.push(timeValue);
                    }
                } else {
                    resultArr.push(
                        formatDatetime(
                            serverTimeToLocal(
                                moment(valArr[i]),
                                isconverttimezones,
                            ),
                            dateFlag,
                        ),
                    );
                }
            }
        }
        if (resultArr.length) {
            return resultArr.join(',');
        }
        return item.initialvalue.display;
    };

    // count search conditions --- add by wanglongx
    const countQueryConditions = (item, multiLang) => {
        let itemtype = searchInfo.itemsMap[item.attrcode].itemtype;
        if (itemtype === 'checkbox') {
            itemtype = 'select';
        }
        switch (itemtype) {
            case 'refer':
                if (Array.isArray(item.initialvalue.display)) {
                    return item.initialvalue.display.join(',');
                }
                return item.initialvalue.display;
            case 'select':
                let options = searchInfo.itemsMap[item.attrcode].options;
                let option = options.find(
                    i => i.value == item.initialvalue.value,
                );
                if (option) {
                    return option.display;
                }
                if (Array.isArray(item.initialvalue.display)) {
                    return item.initialvalue.display.join(',');
                } else {
                    return item.initialvalue.display;
                }
            case 'datepicker':
                return getFuntionValue(item, multiLang);
            case 'NCTZDatePickerEnd':
                return getFuntionValue(item, multiLang);
            case 'NCTZDatePickerStart':
                return getFuntionValue(item, multiLang);
            case 'radio':
                return item.initialvalue.display;
            // case 'checkbox':
            //     return <NCCheckbox checked={!(item.initialvalue.value === 'N' || item.initialvalue.value === false)} disabled />;
            case 'checkbox_switch':
                return (
                    <NCCheckbox
                        checked={
                            !(
                                item.initialvalue.value === 'N' ||
                                item.initialvalue.value === false
                            )
                        }
                        disabled
                    />
                );
            case 'rangepicker':
                return getFuntionValue(item, multiLang);
            case 'datetimepicker':
                return getFuntionValue(item, multiLang);
            default:
                if (Array.isArray(item.initialvalue.value)) {
                    return item.initialvalue.value.join(',');
                } else {
                    return item.initialvalue.value;
                }
        }
    };

    // add by wanglongx

    const createTitle = () => {
        let res = null;

        res = (
            <span>
                {multiLang['page-search-0025']}:{' '}
                <span className="search-conditions-number">
                    (
                    {
                        tree2Array(searchInfo.snapshotMap['simple']).filter(
                            item => checkIsVisible(item),
                        ).length
                    }
                    )
                </span>
            </span>
        );
        return res;
    };

    // 防抖——触发高频事件后 n 秒后函数只会执行一次，如果n毫秒内高频事件再次被触发，则重新计算时间；
    const debounce = (fn, interval) => {
        let timeout = null; // 创建一个标记用来存放定时器的返回值
        return function () {
            if (timeout) {
                clearTimeout(timeout); // 每当事件触发的时候把前一个 setTimeout clear 掉
            }
            timeout = setTimeout(() => {
                // 然后又创建一个新的 setTimeout, 这样就能保证interval间隔时间触发的话，就不会执行 fn 函数
                fn.apply(this, arguments);
            }, interval);
        };
    };

    const searchEnter = event => {
        // if (event.target.className.includes('selection-search-input')) return;
        document.activeElement.blur();
        clickSearch();
    };

    //请求除模板外的查询方案
    const querySchemes = async(url, param) => {
        return await sendAjax.call(this, url, param);
    };

    // 比较两个值(基本类型值或对象）是否一样
    const compare = (a, b) => {
        if (typeof a === 'object' && typeof b === 'object') {
            if (a && b) {
                // 去掉undefined
                a = JSON.parse(JSON.stringify(a));
                b = JSON.parse(JSON.stringify(b));
                var akeys = Object.keys(a),
                    bkeys = Object.keys(b);
                if (akeys.length === bkeys.length) {
                    for (var i = 0, l = akeys.length; i < l; i++) {
                        var flag = compare(a[akeys[i]], b[akeys[i]]);
                        if (!flag) {
                            return false;
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return Object.is(a, b);
            }
        } else {
            return a == b;
        }
    };

    // 将数据存入缓存--命中缓存仍存数据的原因是缓存数据的顺序
    const setCacheData = (url, param, data) => {
        param = JSON.parse(JSON.stringify(param));
        data = JSON.parse(JSON.stringify(data));
        let cacheData = ViewModel.getData('searchSchemaCache') || [];
        let i = cacheData.findIndex(e => {
            return e.url === url && compare(param, e.param);
        });
        if (i > -1) {
            cacheData.splice(i, 1);
        }

        cacheData.push({
            url,
            param,
            data,
        });

        ViewModel.setData('searchSchemaCache', cacheData);
    };

    // 是否命中缓存
    const hasCache = (url, param) => {
        let cacheData = ViewModel.getData('searchSchemaCache') || [],
            cache = cacheData.find(e => {
                return e.url === url && compare(param, e.param);
            });
        if (cache) {
            setCacheData(url, param, cache.data);
            return cache.data;
        } else {
            return null;
        }
    };

    const sendAjax = (url, param) => {
        let cacheData = hasCache(url, param);
        if (cacheData) {
            //处理缓存数据
        } else {
            return new Promise(resolve => {
                ajax({
                    async:true,
                    url,
                    data: param,
                    success: res => {
                        if (!res.success) {
                            throw new Error(res.error.message);
                        }
                        if (res.data && res.data.message) {
                            toast({
                                color: 'warning',
                                content: res.data.message,
                            });
                        }
                        setCacheData(url, param, res.data);
                        resolve(res.data);
                    },
                    error: e => {
                        toast({
                            color: e.type || 'danger',
                            content: e.message,
                        });
                    },
                });
                
            });
        }
    };

    //查询区目前展示方式 ：1、只显示高级按钮 ；2、都显示
    const createSearchDom = () => {
        let { snapshotMap, itemsMap, showAdvModal } = searchInfo;
        let showLableFlag = showSearchLable && this.state.showLable;
        const that = this;
        if (onlyShowSuperBtn) {
            return (
                <div
                    className="lightapp-component-search"
                    style={{ marginTop: '0px' }}
                >
                    {hideBtnArea ? null : createButton()}
                </div>
            );
        } else {
            // 每五个一行 第一行后面放 button
            let allItem = [];
            let temp = [];
            let snapshot_list = tree2Array(snapshotMap['simple']);
            let snapshot = [];
            let itemCount = 0;
            snapshot_list.forEach(element => {
                let val = itemsMap[element.attrcode];
                if (element.visible !== false && val) {
                    //如果是小部件模式的话，只显示isdefault=true的
                    if (!(isWidgetMode && element.isdefault === false)) {
                        let operationOptions = createOperation(
                            val.queryOperateType,
                        );
                        if (operationOptions.length > 0) {
                            if (
                                !operationOptions.some(
                                    i => element.operationSign === i.value,
                                )
                            ) {
                                element.operationSign =
                                    (operationOptions[0] &&
                                        operationOptions[0].value) ||
                                    element.operationSign ||
                                    '=';
                                // element.initialvalue = { display: '', value: '' };
                            }
                            element.operationOptions = operationOptions;
                        }
                        snapshot.push(element);
                    }
                }
            });
            // snapshot = snapshot_list.filter(item => item.visible !== false);
            let firstLineFlag = true;
            const rowColoumn = maxColumn || INITNUM
            snapshot.forEach((item, index) => {
                let val = itemsMap[item.attrcode];
                itemCount++;
                if (val) {
                    temp.push(item);
                    if (temp.length === rowColoumn) {
                        if (firstLineFlag) {
                            temp.push('button');
                            firstLineFlag = false;
                        }
                        allItem.push([...temp]);
                        temp = [];
                    }
                }
            });
            if (snapshot.length === 0) {
                temp = ['button'];
            }
            if (temp.length > 0) {
                allItem.push(temp);
            }
            if (allItem.length === 1) {
                allItem[0].push('button');
            }
            let classLable = '';
            if (showLableFlag && !searchInfo.showSearchItems) {
                classLable = ' search-top-lable';
            }
            // const name123 = searchInfo.multiLangOpt.createName123(searchInfo);
            // let multiLangName = searchInfo.multiLangOpt.getMultiLangValueFromName123(name123);
            
            return (
                // 1909 search add by wanglongx
                // 内部快捷键 enter
                <NCHotKeys
                    className="lightapp-component-search"
                    keyMap={{
                        query: ['enter'],
                        delete: ['Alt+Del'],
                    }}
                    handlers={{
                        delete: () => {
                            // blur 触发保存 强制让 body 获取焦点
                            document.body.focus();
                            resetEvent.call(this);
                        },
                        query: debounce.call(this, searchEnter, 300),
                    }}
                    style={{
                        paddingTop:
                            showLableFlag && !searchInfo.showSearchItems
                                ? '0px'
                                : '6px',
                        display: 'flex',
                    }}
                    attach={false}
                    focused={true}
                >
                    {/* 注册全局 F3 */}
                    <NCHotKeys
                        keyMap={{
                            high: ['f3'],
                            save: ['ctrl+s'],
                            add: ['ctrl+shift+s'],
                        }}
                        handlers={{
                            high: () => {
                 
                                currentSearch &&
                                showAdvBtn &&
                                !showAdvModal &&
                                searchAdvBtnClick(searchInfo);
                                // // f3 部分情况下禁用.
                                // const activeElement = document.activeElement;
                                // const searchDom = document.getElementsByClassName('lightapp-component-search')?[0];
                                
                                // if(document.getElementById('app').contains(activeElement) || activeElement?.tagName == 'BODY'){
                                //     currentSearch &&
                                //     showAdvBtn &&
                                //     !showAdvModal &&
                                //     searchAdvBtnClick(searchInfo);
                                // }

                            },
                            save: e => {
                                let wrapper = ReactDOM.findDOMNode(this);
                                if(!microAppUtil.getDocument().contains(wrapper)){
                                    //只有当前显示的按钮区域，触发快捷键
                                    return;
                                }

                                if (
                                    searchInfo.status !== 'simple' ||
                                    searchInfo.currentPlan.isMyPlan
                                ) {
                                    return;
                                }
                                that.editPlanType && showAdvBtn &&
                                    showAdvSearchPlanBtn &&
                                    currentSearch &&
                                    beSureBtnClick.call(
                                        this.props._this,
                                        'save',
                                        true,
                                        this.targetEditPlan || searchInfo.currentPlan,
                                        "",
                                        false,
                                        searchInfo.sortField,
                                        this,
                                    );
                            },
                            add:
                                showAdvBtn &&
                                showAddSearchPlan &&
                                showAdvSearchPlanBtn &&
                                currentSearch &&
                                addSearchPlanClick,
                        }}
                        display="inline"
                        attach={document.body}
                        focused={true}
                    />
                    {/** 另存新方案弹窗,将该内容提到最外层组件 */}
                    {!isEmpty(multiLang) &&
                        this.props.modal.createModal(
                            'outAddSearchPlan@' + this.props.moduleId,
                            {
                                title: this.editPlanType === 'add' ? multiLang['page-search-0081'] : multiLang['page-search-0082'],
                                content: modalContent.call(
                                    this.props._this,
                                    this.editPlanType,
                                    true,
                                    this.editPlanType === 'add' ? searchInfo.currentPlan : this.targetEditPlan,
                                    searchInfo.searchPlanName,
                                    this,
                                    // multiLangName,
                                    // {
                                    //     name1:{value:searchInfo.name},
                                    //     name2:{value:(searchInfo.name2 ? searchInfo.name2 : searchInfo.name)},
                                    //     name3:{value:(searchInfo.name3 ? searchInfo.name3 : searchInfo.name)}
                                    // }
                                ),
                                // size: 'sm',
                                height: 180,
                                minHeight: 180,
                                minWidth: 400,
                                width: 400,
                                mask: 'static',
                                cancelBtnClick: () => {
                                    searchInfo.searchPlanName = {};
                                    this.editPlanType = '';
                                    this.setState({ checked: false });
                                },
                                closeModalEve: () => {
                                    this.editPlanType = '';
                                    searchInfo.searchPlanName = {};
                                    this.setState({ checked: false });
                                },
                                beSureBtnClick: () =>
                                    beSureBtnClick.call(
                                        this.props._this,
                                        this.editPlanType,
                                        true,
                                        this.editPlanType === 'add' ? searchInfo.currentPlan : this.targetEditPlan,
                                        searchInfo.searchPlanName,
                                        this.state.checked,
                                        searchInfo.sortField,
                                        this,
                                        undefined,
                                        // multiLangName,
                                        // {
                                        //     name1:{value:searchInfo.name},
                                        //     name2:{value:(searchInfo.name2 ? searchInfo.name2 : searchInfo.name)},
                                        //     name3:{value:(searchInfo.name3 ? searchInfo.name3 : searchInfo.name)}
                                        // }
                                    ),
                                leftBtnName: multiLang['page-search-0009'],
                                rightBtnName: multiLang['page-search-0010'],
                                zIndex: this.props.zIndex+60,
                                // onEntered: onInputFocus,
                                className: 'search-modal',
                            },
                        )}
                    {/**有高级功能的情况需要查询方案列表 */}
                    {showAdvBtn && !hideSearchPlan && (
                        <div className={'search-top' + classLable}>
                            <div className="search-edit">
                                <Dropdown
                                    placement="bottomLeft"
                                    visible={this.state.showPlanItem}
                                    trigger={['hover']}
                                    overlay={
                                        <div className="query_condo">
                                            <ul className="query_content">
                                                {createSearchPlan.call(this)}
                                            </ul>
                                            <div
                                                className="create_new"
                                                fieldid={getSysFieldid(
                                                    'create_new_btn',
                                                )}
                                                onClick={e => {
                                                    let classname =
                                                        e.target.className;
                                                    if (
                                                        classname &&
                                                        classname.includes(
                                                            'icon-not-visible',
                                                        )
                                                    ) {
                                                        return;
                                                    }
                                                    searchAdvBtnClick(
                                                        searchInfo,
                                                    );
                                                }}
                                            >
                                                <sapn className="new_content">{` + ${multiLang['page-search-0080']}`}</sapn>
                                                <NCTooltip
                                                    delayShow={800}
                                                    delayHide={1}
                                                    inverse
                                                    overlay={
                                                        multiLang[
                                                            'page-search-0098'
                                                        ]
                                                    }
                                                    placement="top"
                                                >
                                                    <span className="search-plan-shuoming-icon">
                                                        <i
                                                            onMouseEnter={e => {
                                                                e.target.classList.remove(
                                                                    'icon-shuoming1',
                                                                );
                                                                e.target.classList.add(
                                                                    'icon-shuoming2',
                                                                );
                                                            }}
                                                            onMouseLeave={e => {
                                                                e.target.classList.remove(
                                                                    'icon-shuoming2',
                                                                );
                                                                e.target.classList.add(
                                                                    'icon-shuoming1',
                                                                );
                                                            }}
                                                            className="iconfont icon-not-visible icon-shuoming1"
                                                        />
                                                    </span>
                                                </NCTooltip>
                                            </div>
                                        </div>
                                    }
                                    delay={500}
                                    delayShow={500}
                                    overlayClassName="query-plan-dropdown"
                                    onVisibleChange={a => {
                                        if (a) {
                                            //如果hover时，请求除模板之外的其他查询方案，请求接口开启缓存避免重复请求
                                            //hover的时候更新state中的searchInfo.searchPlanCache--该项更新方式参考以下两种
                                            //方式①
                                            // this.state.searchInfo = searchInfo;
                                            // setStateEve();
                                            //方式②
                                            // searchInfo.searchPlanName = value;
                                            // setStateEve();

                                            // //hover的时候去请求接口，若当前searchPlanCache中存在接口返回的数据，说明已经加载过所有查询方案了
                                            // searchInfo.searchPlanCache = [...searchInfo.searchPlanCache,searchInfo.searchPlanCache[1]];
                                            // // this.state.searchInfo = searchInfo;
                                            // console.log('searchInfo',searchInfo);
                                            // console.log('this.props.searchInfo',this.props.searchInfo);
                                            // console.log('this.state',this.state);
                                            // // setStateEve();

                                            //方式③，不在willReceiveProps那里请求接口更新数据，即不操作searchPlanCache，只操作meta
                                            //改为操作meta--参考如下代码--双驱
                                            // const queryschemes = this.state.searchInfo.searchPlanCache;
                                            // this.state.searchInfo.searchPlanName = null;
                                            // //如果将新建的方案设为默认，那就将其他的isdefault都设为false
                                            // if (isquicks) {
                                            //     this.props.meta.defaultDisPlay = res.data;
                                            // }

                                            // queryschemes.push(_clone(saveSearchPlanData));
                                            // //更新模板数据
                                            // this.searchPlanCacheChange(queryschemes);
                                            
                                            /*请求后端其他模板数据，待数据返回后更新模板数据*/
                                            //看下url及请求参数data
                                           
                                            // let appReqParam = getAppReqParam();
                                            // let appcode = appReqParam.appcode;
                                            // let pagecode = this.globalPageCode || appReqParam.pagecode;
                                            // ajax({
                                            //     // url: '/nccloud/riart/queryscheme/addQS.do',
                                            //     url: '/nccloud/platform/templet/getqueryschemelist.do',
                                            //     async: true,//请求是否异步,等待接口返回数据后再执行
                                            //     data: { appcode, pagecode},
                                            //     success: res => {
                                            //         if (res.success) {
                                            //             //这里不应该永远都是默认方案+快速查询+接口返回吗
                                            //             //过滤出默认方案+快速查询后，加接口返回
                                            //             let attachSchemes = res.data || [];
                                            //             const queryschemes = [...searchInfo.searchPlanCache.filter(item => item.isquickqs || item.pk_ncc_queryscheme === '001' || (item.pk_ncc_queryscheme === this.props.meta.defaultPrepared && !item.isquickqs )),...attachSchemes];

                                            //             searchInfo.searchPlanCache = [...queryschemes];
                                            //             this.props._this.searchPlanCacheChange(queryschemes);
                                            //             this.setState({ showFlag: true }); 
                                            //         }
                                            //     },
                                            // });
                                            this.setState({ showFlag: true }); 

                                            // let url = '/nccloud/platform/templet/getqueryschemelist.do';
                                            // let appReqParam = getAppReqParam();
                                            // let appcode = appReqParam.appcode;
                                            // let pagecode = this.globalPageCode || appReqParam.pagecode;
                                            // let param = {appcode, pagecode};
                                            // let attachSchemes = querySchemes(url,param);
                                            // const queryschemes = [...searchInfo.searchPlanCache,...attachSchemes];
                                            // searchInfo.searchPlanCache = [...queryschemes];
                                            // this.props._this.searchPlanCacheChange(queryschemes);
                                            // this.setState({ showFlag: true }); 
                                        }
                                    }}
                                    getPopupContainer={() => {
                                        return (
                                            microAppUtil.getDocument().querySelector(
                                                '.workbench-grid-layout-container',
                                            ) || microAppUtil.getDocument()
                                        );
                                    }}
                                    fieldid="search-plan"
                                >
                                    <div
                                        className="search-name-wrapper"
                                        fieldid={getSysFieldid(
                                            'search-plan_btn',
                                        )}
                                        onClick={this.onChangePlanVisible}
                                    >
                                        <TipsTitle
                                            title={
                                                (searchInfo.currentPlan &&
                                                    searchInfo.currentPlan
                                                        .labelName) ||
                                                searchInfo.defaultPlan.labelName
                                            }
                                            className="search-plan-name"
                                        ></TipsTitle>
                                        <i className="iconfont icon-hangcaozuoxiala1" />
                                    </div>
                                </Dropdown>
                            </div>
                        </div>
                    )}
                    {/**当少于一行的时候收起展示的还是展开的样子 */}
                    {searchInfo.showSearchItems && !onlyShowPlan && (
                        <Dropdown
                            trigger={['hover']}
                            overlayClassName="search-dropdown"
                            minOverlayWidthMatchTrigger={false}
                            delay={300}
                            placement="bottomLeft"
                            overlayStyle={
                                snapshot_list.filter(
                                    item => item.initialvalue.value,
                                ).length
                                    ? {}
                                    : { display: 'none' }
                            }
                            overlay={
                                <div className="search-condition">
                                    {snapshot_list.map(item => {
                                        if (checkIsVisible(item)) {
                                            return (
                                                <p className="search-condition-item">
                                                    <span className="item-title">
                                                        {
                                                            searchInfo.itemsMap[
                                                                item.attrcode
                                                            ].label
                                                        }
                                                    </span>
                                                    <span className="opr_icon">
                                                        {createOperationIcon(
                                                            item.operationSign,
                                                        )}
                                                    </span>
                                                    <span className="item-maohao">
                                                        ：
                                                    </span>
                                                    <span className="item-content">
                                                        {countQueryConditions(
                                                            item,
                                                            multiLang,
                                                        )}
                                                    </span>
                                                </p>
                                            );
                                        }
                                    })}
                                </div>
                            }
                        >
                            <div
                                className="search-conditions-value"
                                onClick={() => {
                                    searchInfo.showSearchItems = false;
                                    setStateEve();
                                }}
                            >
                                <span>
                                    {searchInfo.showSearchItems &&
                                        createTitle()}
                                    &nbsp;&nbsp;
                                    {snapshot_list.map(item => {
                                        if (checkIsVisible(item)) {
                                            return (
                                                searchInfo.itemsMap[
                                                    item.attrcode
                                                ].label + ';'
                                            );
                                        }
                                    })}
                                </span>
                            </div>
                        </Dropdown>
                    )}
                    {/**当收起的时候需要高级和展开两个按钮 */}
                    {searchInfo.showSearchItems &&
                        !onlyShowPlan &&
                        createButton(true)}
                    {/** 展开的时候显示的内容，主要包括查询项，查询、高级、更多、展开收起按钮*/}
                    {!onlyShowPlan && !searchInfo.showSearchItems && (
                        <div className="item-contant">
                            {allItem.map((item, zindex) => {
                                // if (zindex === 0) item.push('button');
                                return (
                                    <div
                                        className="item-rows"
                                        style={{
                                            marginTop:
                                                zindex && !showLableFlag
                                                    ? '6px'
                                                    : '0px',
                                        }}
                                    >
                                        {item.map((data, index) =>
                                            createDom(
                                                data,
                                                index === item.length - 1,
                                                zindex,
                                                index,
                                                itemCount,
                                            ),
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    {onlyShowPlan && createButton(true)}
                </NCHotKeys>
            );
        }
    };
    function isTrueEmpty(data) {
        if (isEmpty(data)) {
            return true;
        } else if (Array.isArray(data)) {
            return data.filter(item => item).length === 0;
        }
    }
    function checkIsVisible(item) {
        if (
            item.operationSign == 'is null' ||
            item.operationSign == 'is not null'
        ) {
            return true;
        } else if (
            !isTrueEmpty(item.initialvalue.value) &&
            item.itemtype != 'refer'
        ) {
            return true;
        } else if (
            !isEmpty(item.initialvalue.display) &&
            item.itemtype == 'refer'
        ) {
            return true;
        } else {
            return false;
        }
    }

    // return isEmpty(multiLang) ? null : createSearchDom();
    return createSearchDom();
}
